module.exports = __webpack_public_path__ + "static/media/logo.c131e38a.png";